var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MESSAGE_EVENT_TYPE } from "./util/matrixUtil";
import { encodeBase64 } from "./util/olmlib";
const DEFAULT_OPTIONS = {
    // set to true to send everything encapsulated in a m.room.message,
    // so you can debug rooms easily in element or other matrix clients
    updatesAsRegularMessages: false,
    updateEventType: "matrix-crdt.doc_update",
    snapshotEventType: "matrix-crdt.doc_snapshot",
};
/**
 * The MatrixCRDTEventTranslator is responsible for writing and reading
 * Yjs updates from / to Matrix events. The options determine how to serialize
 * Matrix-CRDT updates.
 */
export class MatrixCRDTEventTranslator {
    constructor(opts = {}) {
        this.opts = Object.assign(Object.assign({}, DEFAULT_OPTIONS), opts);
    }
    sendUpdate(client, roomId, update) {
        return __awaiter(this, void 0, void 0, function* () {
            const encoded = encodeBase64(update);
            const content = {
                update: encoded,
            };
            if (this.opts.updatesAsRegularMessages) {
                const wrappedContent = Object.assign({ body: this.opts.updateEventType + ": " + encoded, msgtype: this.opts.updateEventType }, content);
                client.scheduler = undefined;
                yield client.sendEvent(roomId, MESSAGE_EVENT_TYPE, wrappedContent, "");
            }
            else {
                yield client.sendEvent(roomId, this.opts.updateEventType, content, "");
            }
        });
    }
    sendSnapshot(client, roomId, snapshot, lastEventId) {
        return __awaiter(this, void 0, void 0, function* () {
            const encoded = encodeBase64(snapshot);
            const content = {
                update: encoded,
                last_event_id: lastEventId,
            };
            if (this.opts.updatesAsRegularMessages) {
                const wrappedContent = Object.assign({ body: this.opts.snapshotEventType + ": " + encoded, msgtype: this.opts.snapshotEventType }, content);
                client.scheduler = undefined;
                yield client.sendEvent(roomId, MESSAGE_EVENT_TYPE, wrappedContent, "");
            }
            else {
                yield client.sendEvent(roomId, this.opts.snapshotEventType, content, "");
            }
        });
    }
    isUpdateEvent(event) {
        if (this.opts.updatesAsRegularMessages) {
            return (event.type === MESSAGE_EVENT_TYPE &&
                event.content.msgtype === this.opts.updateEventType);
        }
        return event.type === this.opts.updateEventType;
    }
    isSnapshotEvent(event) {
        if (this.opts.updatesAsRegularMessages) {
            return (event.type === MESSAGE_EVENT_TYPE &&
                event.content.msgtype === this.opts.snapshotEventType);
        }
        return event.type === this.opts.snapshotEventType;
    }
    get WrappedEventType() {
        if (this.opts.updatesAsRegularMessages) {
            return MESSAGE_EVENT_TYPE;
        }
        else {
            return this.opts.updateEventType;
        }
    }
}
//# sourceMappingURL=MatrixCRDTEventTranslator.js.map